module.exports = __webpack_public_path__ + "static/tcc-5577e1e31acf36220b5b4d00c6741023.png";